import { render, staticRenderFns } from "./ChildWithTokenOpener.vue?vue&type=template&id=9ecb30f6&scoped=true&"
import script from "./ChildWithTokenOpener.vue?vue&type=script&lang=js&"
export * from "./ChildWithTokenOpener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb30f6",
  null
  
)

export default component.exports